import { styled } from "@pigment-css/react";

export const Divider = styled("div")(({ theme }) => ({
  height: "1px",
  backgroundColor: theme.managementView.colors.neutral[8],
  width: "100%",
}));
